import {FC, ReactNode} from 'react';

import {FormatCurrency} from 'components/currency/format-currency';
import {FormatUsdCurrency} from 'components/currency/format-usd-currency';
import {QuotedPaymentMethodFragment, QuoteListFragment, QuotesQuoteCountryChoices} from 'generated/graphql';
import {convertBrlToUsd} from 'utils/currency/exchange-rate';
import {calculatePaymentMethodTotalPriceWithTaxDisplay} from 'utils/quotes/calculator';

interface QuoteTotalPriceProps {
    quote: Partial<QuoteListFragment>;
    paymentMethod?: QuotedPaymentMethodFragment;
};

const renderQuoteListAmount = (brlTotal: number, quote: Partial<QuoteListFragment>): ReactNode => {
    if (quote.country === QuotesQuoteCountryChoices.Others && quote.exchangeRate) {
        const usdTotal = convertBrlToUsd(brlTotal, quote.exchangeRate);
        if (usdTotal !== null) {
            return <FormatUsdCurrency number={usdTotal} />;
        }
    }
    return <FormatCurrency number={brlTotal} />;
};

export const QuoteTotalPrice: FC<QuoteTotalPriceProps> = ({quote, paymentMethod}) => {
    if (paymentMethod) {
        const total = quote.products && calculatePaymentMethodTotalPriceWithTaxDisplay(quote.products, paymentMethod) || 0;
        return (
            <div key={paymentMethod.id} style={{whiteSpace: 'nowrap'}}>
                {paymentMethod.slug}: {renderQuoteListAmount(total, quote)}
            </div>
        );
    }
    return (
        <>
            {quote.paymentMethods?.map(paymentMethod => {
                const total = quote.products && calculatePaymentMethodTotalPriceWithTaxDisplay(quote.products, paymentMethod) || 0;
                return (
                    <div key={paymentMethod.id} style={{whiteSpace: 'nowrap'}}>
                        {paymentMethod.slug}: {renderQuoteListAmount(total, quote)}
                    </div>
                );
            })}
        </>
    );
};
